import { FunctionComponent, ReactNode } from 'react'

import styled from '@emotion/styled'

import { CheckIcon } from '@arcade/web/icons/react'
import { Text } from '@cash-design-system/react'

const StyledScheduleItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${props => props.theme.pxToRem(24)} 0 0;
`

const StyledIconAndDate = styled.div`
  display: flex;
  align-items: center;
`

const StyledDate = styled.div`
  margin-left: ${props => props.theme.pxToRem(8)};
`

const StyledCheckedText = styled.div`
  margin-left: ${props => props.theme.pxToRem(8)};
`

const GreenCircleWhiteCenter = styled.div`
  border-radius: 1rem;
  z-index: 1;
  background-color: ${props => props.theme.colors.cardBackground};
  border: solid ${props => props.theme.colors.primary} ${props => props.theme.pxToRem(4)};
  height: ${props => props.theme.pxToRem(25)};
  width: ${props => props.theme.pxToRem(25)};
`
const IconWrapper = styled.div`
  background-color: ${props => props.theme.colors.primary};
  z-index: 1;
  border-radius: 50%;
  height: ${props => props.theme.pxToRem(25)};
  width: ${props => props.theme.pxToRem(25)};
  display: flex;
  padding: ${props => props.theme.pxToRem(2)};
  color: ${props => props.theme.colors.cardBackground};

  svg {
    height: ${props => props.theme.pxToRem(22)};
    width: ${props => props.theme.pxToRem(22)};
  }
`

interface Props {
  amount: ReactNode
  schedule: ReactNode
  totalCount?: number
  isChecked: boolean
}

export const PaymentScheduleItem: FunctionComponent<Props> = ({ amount, schedule, isChecked }) => {
  return (
    <StyledScheduleItem>
      <StyledIconAndDate>
        {isChecked ? (
          <IconWrapper>
            <CheckIcon />
          </IconWrapper>
        ) : (
          <GreenCircleWhiteCenter />
        )}
        {isChecked ? (
          <StyledCheckedText>
            <Text typography="labelMedium" color="textStandard">
              {schedule}
            </Text>
          </StyledCheckedText>
        ) : (
          <StyledDate>
            <Text typography="labelMedium" color="textSubtle">
              {schedule}
            </Text>
          </StyledDate>
        )}
      </StyledIconAndDate>
      {isChecked ? (
        <StyledCheckedText>
          <Text typography="labelMedium" color="textStandard">
            {amount}
          </Text>
        </StyledCheckedText>
      ) : (
        <div>
          <Text typography="labelMedium" color="textSubtle">
            {amount}
          </Text>
        </div>
      )}
    </StyledScheduleItem>
  )
}
